import React from "react";
import { Accordion, Badge, Group, Paper, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconTicket } from "@tabler/icons-react";
import type { TicketDto } from "../types";
import type { Texts } from "../texts";

type Props = {
    tickets: TicketDto[];
    t: Texts;
};

export default function TicketsSection({ tickets, t }: Props) {
    if (tickets.length === 0) return null;

    return (
        <Accordion.Item value="ticket">
            <Accordion.Control
                icon={
                    <ThemeIcon color="red" variant="light" radius="xl">
                        <IconTicket size={18} />
                    </ThemeIcon>
                }
            >
                {t.ticket}
            </Accordion.Control>

            <Accordion.Panel>
                <Stack gap="sm">
                    {tickets.map((ticket, index) => (
                        <Paper key={ticket.ticketID ?? index} withBorder p="sm" radius="md">
                            <Group justify="space-between" align="flex-start" wrap="nowrap">
                                <div style={{ minWidth: 0 }}>
                                    <Text fw={600} lineClamp={2}>
                                        {ticket.ticketDescription || "-"}
                                    </Text>

                                    <Text size="sm" c="dimmed" mt={4}>
                                        {ticket.ticketTimeStart && ticket.ticketTimeEnd
                                            ? `${new Date(ticket.ticketTimeStart).toLocaleTimeString("da-DK", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })} - ${new Date(ticket.ticketTimeEnd).toLocaleTimeString("da-DK", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })}`
                                            : "-"}
                                    </Text>

                                    {ticket.sourceType && (
                                        <Text size="xs" c="dimmed" mt={4}>
                                            {t.source}: {ticket.sourceType}
                                        </Text>
                                    )}
                                </div>

                                <Badge color={ticket.isUsed ? "gray" : "red"} variant="light">
                                    {ticket.isUsed ? t.used : t.active}
                                </Badge>
                            </Group>
                        </Paper>
                    ))}
                </Stack>
            </Accordion.Panel>
        </Accordion.Item>
    );
}